/**
 * Sections that asks if the content was useful or not.
 * This script is used to show a message when the user clicks on one of the buttons.
 */

const contentFeedbackSection = document.querySelector('.content-feedback');

if (contentFeedbackSection) {
    const toggle = document.querySelector('[data-content-feedback-status]');
    const buttons = document.querySelectorAll('[data-content-feedback-button]');

    buttons.forEach((button) => {
        button.addEventListener('click', () => toggle.setAttribute('data-content-feedback-status', 'answered'));
    });
}
